import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {SignupModule} from '../signup/signup.module';
import {PasswordModule} from '../password/password.module';
import {ForgetComponent} from '../password/forget/forget.component';
import {ResetComponent} from '../password/reset/reset.component';
import {JoinComponent} from '../signup/join/join.component';
import { SharedModule } from '@rubii/frontend-common';
import { SsoComponent } from './sso/sso.component';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
    declarations: [LoginComponent, SsoComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatGridListModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        ReactiveFormsModule,
        MatCardModule,
        MatCheckboxModule,
        SignupModule,
        PasswordModule,
        SharedModule,
        FormsModule
    ]
})
export class LoginModule { }
